<div id="video-container" class="mb-4">
    <div class="container d-flex justify-content-center">
        <div class="row text-center position-relative d-flex justify-content-center" style="z-index: 111; width: 90%;">
            <h2 class="home-title text-white">Amritam 2025 At Hindu College of Pharmacy</h2>
            <p class="text-white">Hindu College of Pharmacy is one of the premier institutions in Haryana, dedicated to
                providing top-notch pharmaceutical education.</p>

            <a class="play-btn" data-bs-toggle="modal" data-bs-target="#staticBackdrop">
                <i class="fa-solid fa-play"></i>
            </a>
        </div>
    </div>
</div>

<div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header border-0">
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="ratio ratio-16x9">
                    <iframe #vimeoVideo
                        src="https://player.vimeo.com/video/1079131744?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                        allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
                        title="Untitled video"></iframe>
                </div>
            </div>
        </div>
    </div>
</div>